import { Component } from 'vue-property-decorator'

Component.registerHooks(['validations'])
